import _ from 'lodash';
import async from 'async';
/** @namespace async.waterfall **/

import { apiFetch } from '../utility';

const SLIDING_MONTH_COMPARISON = 'report/sales/tank/slidingComparision';
const TANK_DAILY_SALES = 'reports/sales/tank/daily';
const TANK_DAILY_INVENTORIES = 'reports/inventory/tank/daily';
const TANK_MONTHLY_SALES = 'reports/sales/tank/monthly';
const STATION_DATA = 'reports/monitoring/STATION_DATA';
const NEW_STATION_SALES_AND_RETAIL = 'reports/monitoring/NEW_STATION_SALES_AND_RETAIL';

const initialState = {
	tankDailySales: undefined,
	tankDailyAverages: undefined,
	salesByMonth: {},
	dataByStationTank: {},
};

export default (state = initialState, action) => {
	let salesByMonth;
	switch (action.type) {
		case TANK_MONTHLY_SALES:
			salesByMonth = {
				...state.salesByMonth,
				[action.key]: action.data,
			};

			return {
				...state,
				salesByMonth,
			};

		case TANK_DAILY_SALES:
			return {
				...state,
				tankDailySales: action.tankDailySales,
				tankDailyAverages: action.tankDailyAverages,
			};

		case NEW_STATION_SALES_AND_RETAIL:
			return {
				...state,
				tankDailySalesPlus: action.tankDailySalesPlus,
				tankMonthlySales: action.tankMonthlySales,
				tankDailyAveragesPlus: action.tankDailyAveragesPlus,
			};

		case TANK_DAILY_INVENTORIES:
			return {
				...state,
				tankDailyInventories: action.tankDailyInventories,
			};

		case SLIDING_MONTH_COMPARISON:
			return {
				...state,
				slidingMonthComparisonResult: action.result,
			};

		case STATION_DATA:
			return {
				...state,
				dataByStationTank: {
					[action.stationTank]: action.fillRecords,
				},
			};
		default:
			return state;
	}
};

export const getMonthlySales = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		const monthYear = `${params.year}_${params.month}`;
		apiFetch({
			method: 'report.sales.tank.monthly.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: TANK_MONTHLY_SALES,
					key: monthYear,
					data: r,
				});
				callback();
			},
		});
	};
};

export const getTankDailySales = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.sales.tank.daily.get',
			params,
			dispatch,
			callback: function (err, r) {
				if (err) {
					console.error(err);
					return callback(err);
				}
				dispatch({
					type: TANK_DAILY_SALES,
					tankDailySales: r.tankDailySales,
					tankDailyAverages: r.tankDailyAverages,
				});
				callback();
			},
		});
	};
};

export const getNewStationsSalesAndRetail = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.newStations.getSalesAndRetail',
			params,
			dispatch,
			callback: function (err, r) {
				if (err) {
					console.error(err);
					return callback(err);
				}
				dispatch({
					type: NEW_STATION_SALES_AND_RETAIL,
					tankDailySalesPlus: r.tankDailySalesPlus,
					tankMonthlySales: r.tankMonthlySales,
					tankDailyAveragesPlus: r.tankDailyAveragesPlus,
				});
				callback();
			},
		});
	};
};

export const getSlidingMonthComparison = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.sales.tank.slidingMonthComparison',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: SLIDING_MONTH_COMPARISON,
					result: r,
				});
				callback();
			},
		});
	};
};

export const getTankDailyInventories = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'report.inventory.tank.daily.get',
			params,
			dispatch,
			callback: function (err, r) {
				dispatch({
					type: TANK_DAILY_INVENTORIES,
					tankDailyInventories: r.tankDailyInventories,
				});
				callback();
			},
		});
	};
};

export const getStationData = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		const stationTank = `${params.stationId}_${params.tankNumber}`;

		let deliveryRecords, inventoryRecords;
		async.waterfall(
			[
				(callback) => {
					apiFetch({
						method: 'deliveryRecord.search',
						params,
						dispatch,
						callback,
					});
				},
				(r, callback) => {
					deliveryRecords = _.get(r, ['collections', 'deliveryRecordCollection']);
					apiFetch({
						method: 'inventoryRecord.search',
						params,
						dispatch,
						callback,
					});
				},
				(r, callback) => {
					inventoryRecords = _.get(r, ['collections', 'inventoryRecordCollection']);
					apiFetch({
						method: 'salesRecord.search',
						params,
						dispatch,
						callback,
					});
				},
			],
			(err, r) => {
				if (err) {
					return callback(err);
				}

				const salesRecords = _.get(r, ['collections', 'salesRecordCollection']);

				const fillRecords = _.orderBy(
					deliveryRecords.concat(inventoryRecords, salesRecords),
					(r) => {
						/** @namespace r.salesDate **/
						/** @namespace r.endDateTime **/

						if (r.inventoryDateTime) {
							return r.inventoryDateTime;
						} else if (r.salesDate) {
							return r.salesDate;
						} else {
							return r.endDateTime;
						}
					},
					['desc']
				);

				dispatch({
					type: STATION_DATA,
					stationTank,
					fillRecords,
				});
				callback();
			}
		);
	};
};

export const addInventoryRecord = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'inventoryRecord.add',
			listNameToUpdate: 'inventoryRecordIds',
			params,
			dispatch,
			successMessage: `Inventory record added successfully.`,
			callback: (err) => {
				if (err) {
					return callback(err);
				}
				dispatch(
					getTankDailyInventories({
						callback,
					})
				);

				if (params.stationId) {
					dispatch(
						getStationData({
							params,
							callback,
						})
					);
				}
			},
		});
	};
};

export const updateInventoryRecord = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'inventoryRecord.update',
			listNameToUpdate: 'inventoryRecordIds',
			params,
			dispatch,
			successMessage: `Inventory record updated successfully.`,
			callback: (err) => {
				if (err) {
					return callback(err);
				}
				dispatch(
					getTankDailyInventories({
						callback,
					})
				);

				if (params.stationId) {
					dispatch(
						getStationData({
							params,
							callback,
						})
					);
				}
			},
		});
	};
};

export const addDeliveryRecord = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'deliveryRecord.add',
			listNameToUpdate: 'deliveryRecordIds',
			params,
			dispatch,
			successMessage: `Delivery record added successfully.`,
			callback: (err) => {
				if (err) {
					return callback(err);
				}
				dispatch(
					getStationData({
						params,
						callback,
					})
				);
			},
		});
	};
};

export const updateDeliveryRecord = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: 'deliveryRecord.update',
			listNameToUpdate: 'deliveryRecordIds',
			params,
			dispatch,
			successMessage: `Delivery record updated successfully.`,
			callback: (err) => {
				if (err) {
					return callback(err);
				}
				dispatch(
					getStationData({
						params,
						callback,
					})
				);
			},
		});
	};
};
